export default __webpack_public_path__ + "static/media/user.99b6c0a3.svg";